import {
  defaultSettings,
} from '@components/Widgets/_contentItems/_baseTemplate'

export const defaultStyling = {
  baseColor: '#18171A',
  startColor: '#99A9BF',
  middleColor: '#F7BA2A',
  endColor: '#FF9900',
  align: 'center',
}

export default {
  id: '09345093',
  type: 'rank',
  category: 'form',
  // active: false, ?
  content: {
    // text: 'I am a star rating',
  },
  settings: {
    ...defaultSettings,
    count: 5,
    // star/numeric/heart/face
    type: 'star',
    required: false,
    label: 'New Rating',
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: { ...defaultStyling },
}
